<template>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-skeleton"></require>
  <require from="components/administrators-panel"></require>

  <as-page-jumbo icon="fas fa-user-shield fa-fw" heading="Administrators" intro="Add or remove administrators.">
  </as-page-jumbo>
  <form class="container-fluid">
    <div if.bind="loaded">
      <administrators-panel administrators.bind="administrators" is-administrator-editing.bind="isAdministratorEditing"></administrators-panel>
    </div>
    <as-form-skeleton else></as-form-skeleton>
  </form>
</template>
